import { Controller } from '@hotwired/stimulus';

const PROHIBIDOS_CSV = [
  'imprimir_actilla[mostrar_estadisticas]',
  'imprimir_actilla[mostrar_asignaturas_pendientes]',
  'imprimir_actilla[mostrar_alumnos_con_pendientes_este_curso]',
];

/* global $, init_datepicker */
export default class extends Controller {
  connect() {
    init_datepicker(this.element, { daysOfWeekDisabled: [0, 6] });

    // FIXME: Todo esto no sería necesario si se usa un select con dos opcioens "PDF" y "CSV"
    // en el formulario
    $(this.element).on('click', '.link-imprimir', (e) => {
      const form = this.element.querySelector('form.imprimir_actilla');
      let { format } = e.currentTarget.dataset;

      if (format == null) {
        format = $("input[name*='imprimir_actilla[tipo_actilla]']:checked").val();
      }

      let action = form.getAttribute('action');
      action = action.substring(0, action.indexOf('.') + 1);
      action = `${action}${format}`;

      form.setAttribute('action', action);
    });

    this.#gestionarBotonesImprimir();
  }

  #gestionarBotonesImprimir() {
    const selectorRadios = 'input[name^="imprimir_actilla"]';

    this.element.querySelectorAll(selectorRadios).forEach((radio) => {
      radio.addEventListener('change', () => {
        const seleccionados = document.querySelectorAll(`${selectorRadios}:checked`);
        let csvProhibido = false;
        let pdfProhibido = false;
        seleccionados.forEach((check) => {
          if (PROHIBIDOS_CSV.includes(check.getAttribute('name'))) {
            csvProhibido = true;
          }
          if (check.classList.contains('imprimir_objetivos')) {
            pdfProhibido = true;
          }
        });
        $('.imprimir-pdf').toggleClass('hide', pdfProhibido);
        $('.imprimir-csv').toggleClass('hide', csvProhibido);
      });
    });
  }
}
